const sidebarNav = [
  {
    link: "/upload-file",
    section: "Upload Files",
    icon: "lucide:layout-dashboard", //width:"20"
    text: "Upload Files",
  },
  {
    link: "/dashboard",
    section: "dashboard",
    icon: "ic:round-inventory",
    text: "Dashboard",
  },
  {
    link: "/t-documents",
    section: "T-Documents",
    icon: "ic:baseline-space-dashboard",
    text: "T-Documents Dashboard",
  },
  // {
  //   link: "/inventory",
  //   section: "inventory",
  //   icon: "ic:round-inventory",
  //   text: "Inventory",
  // },
];

export default sidebarNav;
